import { CommonModule } from '@angular/common';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { HomeService } from 'src/app/services/home/home.service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { SpinnerComponent } from "../../layout/spinner/spinner.component";
import { ErrorComponent } from "../../layout/error/error.component";
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  selector: 'app-home',
  imports: [CommonModule, DragDropModule, SpinnerComponent, ErrorComponent, FormsModule, ReactiveFormsModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent {

  data: any
  load = false
  loadUpdate = false

  error = false

  selected: any = null;
  isEdit = false
  editBtnLoad = false
  @ViewChild('formModal') formModalTemplate!: TemplateRef<any>;
  form: FormGroup;

  selectedItems: any
  selectedItem: string = 'news'

  selectedPage: any
  selectLoad = false
  selecterror = false

  isSlider = false

  loadSave = false

  meta: any
  seoForm!: FormGroup;

  constructor(
    private HomeService: HomeService,
    private ToastrService: ToastrService,
    private modalService: NgbModal,
    private fb: FormBuilder,
  ) {
    this.seoForm = this.fb.group({
      keywords: new FormControl('', [Validators.required]),
      description: new FormControl('', [Validators.required]),
    });

    this.get();
    this.seo();
  }


  get(){
    this.load = true
    this.HomeService.getHome().subscribe(
      (res: any) => {
        this.load = false
        this.error = false
        this.data = res

      },
      (error: any) => {
        this.load = false
        this.error = true
      }
    )
  }


  seo(){
    this.load = true
    this.HomeService.getSeo().subscribe(
      (res: any) => {
        this.load = false
        this.error = false
        this.meta = res;

        // API returns array like: [{ id: 1, keywords: "...", description: "..." }]
        const first = Array.isArray(res) ? res[0] : res;
        this.seoForm.patchValue({
          keywords: first?.keywords ?? '',
          description: first?.description ?? '',
        });
      },
      (error: any) => {
        this.load = false
        this.error = true
      }
    )
  }

  saveSeo(): void {
    if (this.seoForm.invalid) {
      this.seoForm.markAllAsTouched();
      this.ToastrService.warning('შეავსე ყველა ველი');
      return;
    }

    const payload = {
      id: Array.isArray(this.meta) ? this.meta?.[0]?.id : this.meta?.id,
      keywords: this.seoForm.value.keywords,
      description: this.seoForm.value.description,
    };

    this.loadSave = true;
    this.HomeService.updateSeo(payload).subscribe(
      (_res: any) => {
        this.loadSave = false;
        this.ToastrService.success('შენახულია');
        this.seo();
      },
      (_err: any) => {
        this.loadSave = false;
        this.ToastrService.error('ვერ შეინახა');
      }
    );
  }

}
